<template>
     <nav class="jobs-nav" aria-label="breadcrumb" ref="tableContainer">
            <div class="job-details">
                <div class="title">{{  vacancy.jobTitle }}</div>
               <div class="sub-details">
                    <div class="jobType">{{  vacancy.jobType }} &#x1F784; {{  vacancy.location }} &#x1F784; {{ vacancy.closingDate }}</div>
               </div>
            </div>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link class="breadcrumb-link" 
                    :to="{ name:'applicants-list'}">Applicants</router-link></li>
                <li class="breadcrumb-item"><router-link class="breadcrumb-link"
                        :to="{name: 'shortlisted-list'}">Shortlist</router-link></li>
            </ol>
    </nav>
    <div class="tables theme-card" ref="tableShortlisted">
        <div class="widget-loading-indicator" v-if="loading">
            <LoadingIndicator v-if="loading" message="Loading Shortlisted"/>
        </div>
        <div v-if="!loading" class="table-header">
                <div class="table-title"><span>Shortlisted</span> <span v-if="shortlistMeta != null" title="Total Shortlisted Candidates" class="total">{{ shortlistMeta.totalCount }}</span></div>
                <div v-if="shortlistMeta != null" class="page-count" :title="'page ' + currentPage + ' of ' + shortlistMeta.totalPages">{{currentPage}}/{{ shortlistMeta.totalPages > 0 ? shortlistMeta.totalPages : 1 }}</div>
            </div>
            <div class="table-content">

                 <div v-if="!loading" class="table-tools" style="display:flex;justify-content: space-between;align-items:center;">
                        <div class="table-actions">
                            <button type="button" class="search-btn" :disabled="searchBtnClicked" @click="loadInitPageForSearch">
                                <SearchIcon/>
                            </button>
                            <input type="text" v-model="searchBody.searchTerm" class="search-query" placeholder="Search Applicants" @keyup.enter="loadInitPageForSearch">
                            <button type="button" class="search-btn" :disabled="cancelBtnClicked" style="background:var(--background)!important;color:var(--page-header)!important;margin-left:0.5rem;" v-if="isSearch" @click="loadInitPage">
                                <CloseIcon/>
                            </button>
                        </div>  
                            <button class="delete-all" @click="showDeleteAllOptions" :disabled="deleteAllBtnClicked">
                                <span style="font-size:0.9rem;">{{ deleteAllBtnClicked == true ? 'Deleting...' : 'Delete All' }}</span></button>
                </div>


                <table v-if="!loading" id="myTable" class="display">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>&nbsp;</th>
                        <th>Status</th> <!--summoned -->
                        <th>&nbsp;</th>
                        <!-- <th>&nbsp;</th> -->
                        <!-- <th style="text-align:center;">Interviewed</th> -->
                        <!-- <th>&nbsp;</th> -->
                        <!-- <th>&nbsp;</th> -->
                        <!-- <th style="text-align:center;">Passed</th> 
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>  -->
                    </tr>
                </thead>
                <tbody>
                    <!-- item -->
                     <tr v-for="shortlisted in shortlist">
                        <td title="User's Fullname"><div class="row-context">{{shortlisted.fullname}}</div></td>
                        <td></td> 
                        <td class="check-td buttons-td">
                            <button @click="isCalled(shortlisted)" :class="shortlisted.isCalled ? 'btn btn-default progress-btn progress-checked' : 'btn btn-default progress-btn'">Called</button>
                            <button @click="isInterviewed(shortlisted)" :class="shortlisted.isInterviewed ? 'btn btn-default progress-btn progress-checked':'btn btn-default progress-btn'">Interviewed</button>
                            <button @click="hasPassed(shortlisted)" :class="shortlisted.hasPassed ? 'btn btn-default progress-btn progress-checked':'btn btn-default progress-btn'">Passed</button>
                            <!-- <input class="form-check-input" type="checkbox" @change="isCalled(shortlisted)" v-model="shortlisted.isCalled"> -->
                        </td> 
                        <!-- <td></td>  -->
                         <!-- <td class="check-td">
                            <input class="form-check-input" type="checkbox" @change="isInterviewed(shortlisted)" v-model="shortlisted.isInterviewed">
                        </td>  -->
                         <!-- <td></td>  -->
                          <!-- <td class="check-td"><input class="form-check-input passed" type="checkbox" @change="hasPassed(shortlisted)" v-model="shortlisted.hasPassed"></td>  -->
                         <!-- <td></td>  -->
                         <td>
                            <div class="icon-buttons">

                                 <button @click="setForRemoval(shortlisted)" title="Remove from shortlist" style="color: var(--page-header);" class="icon-button">
                                    <UserUncheckIcon class="icon-button-icon warning"/>
                                </button>
                                 <button title="Delete candidate" @click="setForDelete(shortlisted)" style="color: var(--red);" class="icon-button">
                                    <TrashIcon class="icon-button-icon"/>
                                </button>
                            </div>
                        </td>
                    </tr>

                   
                    <!--  -->

                </tbody>
            </table>
            <div v-if="!loading" class="custom-pagination" style="margin-top:2rem;">
                    <button class="btn btn-default btn-sm pager-btn" :disabled="currentPage === 1" @click="prevPage">Prev</button>
                    <button class="btn btn-default btn-sm pager-btn" :disabled="shortlist.length < 20" @click="nextPage">Next</button>
            </div>


                

            </div>
    </div>
    <ToastMessage 
        ref="shortlistToast"
        :message="toast.message"
        :success="toast.success"/>
     <WarningOptionsModal
            ref="delShortlisted"
            :body="this.delModal.body"
            :title="this.delModal.title"
            :close-modal="this.delModal.closeModal"
            :yes-selected="this.delModal.yesSelected"
            :yes-button-label="this.delModal.yesButtonLabel"
            :no-button-label="this.delModal.noButtonLabel"
            :modal-id="this.delModal.modalId"
            loading-button-label="Deleting As Shortlisted..."
            />
    <WarningOptionsModal
            ref="delAllShort"
            :body="this.delAllModal.body"
            :title="this.delAllModal.title"
            :close-modal="this.closeDelAllModal"
            :yes-selected="this.deleteAll"
            :yes-button-label="this.delAllModal.yesButtonLabel"
            :no-button-label="this.delAllModal.noButtonLabel"
            :modal-id="this.delAllModal.modalId"
            loading-button-label="Deleting Shortlist..."
            />
</template>
<script>
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import TrashIcon from '@/components/IconComponents/TrashIcon.vue';
import CloseIcon from '@/components/IconComponents/CloseIcon.vue';
import SearchIcon from '@/components/IconComponents/SearchIcon.vue';
import UserCheckIcon from '@/components/IconComponents/UserCheckIcon.vue';
import UserUncheckIcon from '@/components/IconComponents/UserUncheckIcon.vue';
import DataTable from 'datatables.net-dt'; 
import ToastMessage from '@/components/modals/ToastMessage.vue';
import WarningOptionsModal from '@/components/modals/WarningOptionsModal.vue';
import { toggleApplicantShortlistAsync,
        toggleIsCalledAsync,
        toggleIsInterviewedAsync,
        toggleHasPassedAsync,
        deleteAllShortlistedAsync,
        deleteApplicantAsync } from '@/services/employers/applicantsService'; 

export default {
    components:{
        LoadingIndicator,
         TrashIcon, 
         CloseIcon, 
         SearchIcon,
          UserCheckIcon,
           UserUncheckIcon,
           ToastMessage,
           WarningOptionsModal

    },
    computed:{
        shortlist(){
            return this.$store.getters["jobApplicants/getShortlist"] || [];       
        },
        shortlistMeta(){
            return this.$store.getters['jobApplicants/getShortlistMetaData'] || null;
        },
        vacancy(){
            return this.$store.getters["jobApplicants/getVacancy"] || {};
        }
    },
     mounted(){
        this.loadInitPage(1);
        this.table = new DataTable('#myTable', {
                       dom: 'rt',
                       scrollY: 300,
                       scrollCollapse: false,
                       ordering: false,
                       paging: false,
                       searching: false
            });
    },
    data(){
        return{
            searchQuery: '',
            table: null,
            currentPage: 1,
            totalPages: 0,
            pagerPages: [],
            pageSize: 10,
            totalRecords: 0,

            loading: true,
            modal:{
                caption:"",
                message:""
            },
            modalButtonLabel:'Close',
            modalId:"empVac",
            isSearch:false,
            searchBody:{
                searchTerm:"",
                jobId:""
            },
            delModal:{
                title:"",
                body:"",
                modalId:"delShort",
                yesButtonLabel:"Yes",
                noButtonLabel:"No",
                closeModal: null,
                yesSelected: null
            },
             delAllModal:{
                title:"Delete Shortlist",
                body:"<p>You are about to delete the entire shortlist.</br>Note that this is action does <b>NOT</b> remove all of your applicants but clearing the shortlist is irreversible.<p/><p>Are you sure want to delete your shortlist?</p>",
                modalId:"delAllShort",
                yesButtonLabel:"Delete Shortlist",
                noButtonLabel:"Cancel"
            },
            editModal:{
                modalId:"editVac",
                vacancy: null
            },
            eyeButtonDisabled: false,
            searchBtnClicked: false,
            cancelBtnClicked: false,
            deleteAllBtnClicked: false,
            toast:{
                message:"",
                success:true
            }
        }
    },
    methods:{
        showDeleteAllOptions(){
            this.showDelAllModal();
        },
         async loadInitPage(){ //load the first page upon page visit
            try{
            this.cancelBtnClicked = true; //for when a user cancels search. Just keep it here
            this.currentPage = 1;
            this.isSearch = false;
            this.searchBody.searchTerm = "";
            let data = {
                jobId: this.vacancy.jobId,
                page: this.currentPage
                }
            await this.$store.dispatch("jobApplicants/getShortlistAsync", data);

            this.loading = false;
            this.cancelBtnClicked = false;
            }catch(e){
                this.loading = false;
                this.cancelBtnClicked = false;
                // this.modal.caption = e.reason;
                // this.modal.message = e.message;
                // this.showModal();

                let message = e.message == 'Failed to fetch' ? 'Unable to get shortlisted candidates. Check your internet connection or try refreshing the page.' : e.message;
                this.toast = {
                    message: message,
                    success: false
                }
                this.showToastMessage(); 
            }
        },
         async loadInitPageForSearch(){ //load the first page upon search
            try{
            this.searchBtnClicked = true;
            this.currentPage = 1;
            this.searchBody.jobId = this.vacancy.jobId; //set jobId
            await this.$store.dispatch("jobApplicants/searchShortlistAsync", {
                data: this.searchBody,
                page: this.currentPage
            });
            this.isSearch = true;
            this.loading = false;
            this.searchBtnClicked = false;
            }catch(e){
                this.loading = false;
                this.searchBtnClicked = false;
                // this.modal.caption = e.reason;
                // this.modal.message = e.message;
                // this.showModal();

                let message = e.message == 'Failed to fetch' ? 'Unable to get search results of shortlisted candidates. Check your internet connection or try again.' : e.message;
                this.toast = {
                    message: message,
                    success: false
                }
                this.showToastMessage(); 
            }
        },
        setForDelete(shortlisted){ //
            this.delModal.title = "Delete Applicant",
            this.delModal.body = `<b>WARNING!</b></br>You are about to permanently delete ${shortlisted.fullname} as an applicant.` +
                                 ` Note that this action is irreversible.<br>`+
                                 `Are you sure you want to permanently delete them as an applicant?</br>`;
            //this.delAllModal.yesButtonLabel = "Delete Applicant";
            this.delModal.yesSelected = async() => await this.deleteShortlistedApplicant(shortlisted);
            this.delModal.closeModal = () => this.closeDelModal();
            this.showDelModal();
        },
         setForRemoval(shortlisted){ //
            this.delModal.title = "Remove From Shortlist",
            this.delModal.body = `Are you sure you want to remove ${shortlisted.fullname} from the shortlist?</br>` +
            `You can add them back if you change your mind.`
            //this.delModal.yesButtonLabel = "Remove From Shortlist" 
            this.delModal.yesSelected = async() => await this.removeFromShortlist(shortlisted);
            this.delModal.closeModal = () => this.closeDelModal();
            this.showDelModal();
        },
        async goToPage(page){
            try{
            if(!this.isSearch){ 
              
             let data = {
                jobId: this.vacancy.jobId,
                page
            }

            await this.$store.dispatch("jobApplicants/getShortlistAsync", data);
            }else{
                await this.$store.dispatch("jobApplicants/searchShortlistAsync", {
                data: this.searchBody,
                page: page
            });
            }
              this.$nextTick(() => {
                    this.$refs.tableContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
            }catch(e){
                let message = e.message == 'Failed to fetch' ? 'Unable to navigate to page. Check your internet connection.' : e.message;
                this.toast = {
                    message: message,
                    success: false
                }
                this.showToastMessage(); 
            }
        },
         async prevPage() {
            if(this.currentPage > 1){

                await this.goToPage(this.currentPage -= 1);
            }
        },
        async nextPage() {
            await this.goToPage(this.currentPage += 1);
        },
          async deleteAll(){
            try{
            this.closeDelAllModal();
            this.deleteAllBtnClicked = true;
            await this.$store.dispatch("jobApplicants/deleteAllJobShortlistedAsync", this.vacancy.jobId);
            this.deleteAllBtnClicked = false;
             this.toast = {
                    message:"Your shortlist has been cleared",
                    success: true
            }
            this.showToastMessage();
            }catch(e){
                this.deleteAllBtnClicked = false;
               this.toast = {
                    message:"Unable to clear the shortlist. Please check your connection or try again later",
                    success: false
                }
                this.showToastMessage();
            }
        },
         closeDelAllModal(){
            if (this.$refs.delAllShort && typeof this.$refs.delAllShort.hide === 'function') {
                this.$refs.delAllShort.hide();
            }
        },
        async removeFromShortlist(shortlisted){
             try{
                this.closeDelModal();
                let response = await toggleApplicantShortlistAsync({
                    applicantId: shortlisted.applicantId,
                    jobId: this.vacancy.jobId
                });
                if(!response.success){
                    let err = new Error(response.message);
                    err.reason = response.caption;
                    throw err;
                }else{
                    shortlisted.isShortlisted = response.isShortlisted;
                    this.$store.dispatch("jobApplicants/removeShortlistedApplicant", shortlisted.applicantId);
                    
                    let message = `${shortlisted.fullname} has been removed from Shortlist`
                    this.toast = {
                        message: message,
                        success: true
                    }
                    this.showToastMessage();
                }
            }catch(e){
                let message = `Failed to remove ${shortlisted.fullname} from Shortlist. Check your connection or try again later`
                    this.toast = {
                        message: message,
                        success: false
                    }
                    this.showToastMessage();
            }
        },
        async isCalled(shortlisted){
             try{
                let response = await toggleIsCalledAsync({
                    applicantId: shortlisted.applicantId,
                    jobId: this.vacancy.jobId
                });
                if(!response.success){
                    let err = new Error(response.message);
                    err.reason = response.caption;
                    throw err;
                }else{
                    shortlisted.isCalled = response.isCalled;
                    this.$store.dispatch("jobApplicants/updateShortlist", shortlisted);

                    let message = response.isCalled == true ? `${shortlisted.fullname} has been marked as Called`:`${shortlisted.fullname} has been removed as Called`
                    this.toast = {
                        message: message,
                        success: true
                    }
                    this.showToastMessage();

                }
            }catch(e){
                //revert back to initial value in the checkmark
                shortlisted.isCalled = !shortlisted.isCalled
                this.$store.dispatch("jobApplicants/updateShortlist", shortlisted);

                 let message = shortlisted.isCalled == true ? `Failed to remove ${shortlisted.fullname} as Called. Check your connection or try again later`: `Failed to mark ${shortlisted.fullname} as Called. Check your connection or try again later`
                this.toast = {
                    message: message,
                    success: false
                }
              this.showToastMessage();
            }
        },
        async isInterviewed(shortlisted){
             try{
                let response = await toggleIsInterviewedAsync({
                    applicantId: shortlisted.applicantId,
                    jobId: this.vacancy.jobId
                });
                if(!response.success){
                    let err = new Error(response.message);
                    err.reason = response.caption;
                    throw err;
                }else{
                    shortlisted.isInterviewed = response.isInterviewed;
                    this.$store.dispatch("jobApplicants/updateShortlist", shortlisted);

                    let message = response.isInterviewed == true ? `${shortlisted.fullname} has been marked as Interviewed`:`${shortlisted.fullname} has been removed as Interviewed`
                    this.toast = {
                        message: message,
                        success: true
                    }
                    this.showToastMessage();
                }
            }catch(e){
                //revert back to initial value in the checkmark
                shortlisted.isInterviewed = !shortlisted.isInterviewed
                this.$store.dispatch("jobApplicants/updateShortlist", shortlisted);

                 let message = shortlisted.isInterviewed == true ? `Failed to remove ${shortlisted.fullname} as Interviewed. Check your connection or try again later`: `Failed to mark ${shortlisted.fullname} as Interviewed. Check your connection or try again later`
                this.toast = {
                    message: message,
                    success: false
                }
              this.showToastMessage();


            }
        },
        async hasPassed(shortlisted){
             try{
                let response = await toggleHasPassedAsync({
                    applicantId: shortlisted.applicantId,
                    jobId: this.vacancy.jobId
                });
                if(!response.success){
                    let err = new Error(response.message);
                    err.reason = response.caption;
                    throw err;
                }else{
                    shortlisted.hasPassed = response.hasPassed;
                    this.$store.dispatch("jobApplicants/updateShortlist", shortlisted);

                    let message = response.hasPassed == true ? `${shortlisted.fullname} has been marked as Passed`:`${shortlisted.fullname} has been removed as Passed`
                    this.toast = {
                        message: message,
                        success: true
                    }
                    this.showToastMessage();
                }
            }catch(e){
                //revert back to initial value in the checkmark
                shortlisted.hasPassed = !shortlisted.hasPassed
                this.$store.dispatch("jobApplicants/updateShortlist", shortlisted);

                 let message = shortlisted.hasPassed == true ? `Failed to remove ${shortlisted.fullname} as Passed. Check your connection or try again later`: `Failed to mark ${shortlisted.fullname} as Passed. Check your connection or try again later`
                this.toast = {
                    message: message,
                    success: false
                }
              this.showToastMessage();
            }
        },
         showToastMessage(){
             this.$nextTick(() => {
                if(this.$refs.shortlistToast != null){
                    this.$refs.shortlistToast.show();
                }
            });
        },
         showDelModal(){
            this.$refs.delShortlisted.show();
        },
        closeDelModal(){
            this.$refs.delShortlisted.hide();
        },
        async deleteShortlistedApplicant(shortlisted){ 
              try{
                this.closeDelModal();
                let response = await deleteApplicantAsync({
                    applicantId: shortlisted.applicantId,
                    jobId: this.vacancy.jobId
                });
                if(!response.success){
                    let err = new Error(response.message);
                    err.reason = response.caption;
                    throw err;
                }else{
                    shortlisted.isShortlisted = false;//false because its deleted in the database
                    this.$store.dispatch("jobApplicants/removeShortlistedApplicant", shortlisted.applicantId);
                    
                    let message = `${shortlisted.fullname} has been permanently deleted as an Applicant`
                    this.toast = {
                        message: message,
                        success: true
                    }
                    this.showToastMessage();
                }
            }catch(e){
                let message = `Failed to delete ${shortlisted.fullname} as an Applicant. Check your connection or try again later`
                    this.toast = {
                        message: message,
                        success: false
                    }
                    this.showToastMessage();
            }
        },
        showDelAllModal(){
            this.$refs.delAllShort.show();
        }
    }
}
</script>
<style scoped>

.progress-btn{
    width:100%;
    border-radius:0px;
    /* border-bottom:2px solid var(--placeholder)!important; */
    color:var(--placeholder);
    background:var(--background);
    font-size:0.8rem;
    text-transform:uppercase;
    font-family: var(--heading-font-regular);
}

.progress-checked{
    color:var(--enterprise-button);
    background:var(--green);
    /* border-bottom:2px solid var(--green)!important; */
}

.progress-btn:hover{
    color:var(--green);
    border-bottom:2px solid var(--green)!important;
}

.progress-btn:first-child{
    border-top-left-radius:100px;
    border-bottom-left-radius:100px;
}

.progress-btn:last-child{
    border-top-right-radius:100px;
    border-bottom-right-radius:100px;
}

.buttons-td{
    display: flex;
    column-gap:0.1rem;
}

.page-count{
    color: var(--page-header);
    /* font-family:var(--page-header-font); */
    font-family: var(--heading-font-regular);
    font-size: 1rem;
}

.total{
    color:var(--placeholder);
}

.delete-all{
    padding-top:0.35rem;
}

.form-check-input{
    justify-self: center;
}



.check-td{
    /* display: grid; */
}

.pager-btn {
    min-width: 36px;
    height: 36px;
    padding: 0 10px;
    border-radius: 8px;
    border:0px;
    background: transparent;
    color: var(--page-header)!important;
    cursor: pointer;
    font-size:0.8rem;
    text-transform:uppercase;
    font-family: var(--heading-font-regular);
}
.pager-btn.current {
    background: var(--primary, var(--primary-color, #007bff));
    color: #fff;
    border-color: var(--primary, var(--primary-color, #007bff));
}
.pager-btn:disabled {
    opacity: 0.5;
    cursor: default;
    color:var(--placeholder)!important;
}
    
.custom-pagination {
    display: flex;
    gap: 6px;
    align-items: center;
    margin-top: 12px;
}

     .icon-buttons{
        display: flex;
        justify-content: right;
    }

     .icon-button{
        border:0px;
        background: transparent;
    }

    .icon-button-icon{
        height:1rem;
    }

    .warning{
    color:var(--orange);
}

.app-table-head{
    display:grid;
    grid-template-columns: 1fr 1fr 1fr;
   
}

th{
    font-family: var(--body-font-bold)!important;
    flex:1;
}

.table-actions {
    margin-top:0.5rem;
    display: flex;

}


.search-query{
    padding:0.5rem 0.8rem;
     width:25rem;
    margin-bottom:1rem;
}

.table-title {
    font-family:var(--page-header-font);
    color: var(--page-header);
    font-size:1.2rem;
}

.table-header {
    display: flex;
    justify-content: space-between;
}
 
.theme-card{
    margin:0rem;
    border-radius:18px;
    background-color: var(--intro-background);
}

.tables{
    margin-top:1rem;
}

.table-content {
    overflow-x: auto;
}

.search-btn{
    height:2.2rem;
    width: 2.2rem;
    background-color: var(--page-header)!important;
     color:var(--enterprise-button)!important;
}

.table-actions .search-btn {
    font-size:0.9rem;
    border-radius: 6px;
    border:0px;
    border-radius: 100px;
    background: var(--icon-blue);
    margin-right:0.5rem;
    color: #fff;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:0.5rem 0.6rem;
}


/**Navbar */

   
    .location{
        border-left:1px solid var(--sidenav-link)!important;
        border-right:1px solid var(--sidenav-link)!important;
        padding:0rem 1rem;
    }


.page-nav{
        margin-top:0rem;
    }

    .breadcrumb{
        margin:0px!important;
    }

    .jobs-nav{
         background-color: var(--intro-background);
        border-bottom:0px;
        display:grid;
        grid-template-rows:auto auto;
        row-gap:0.7rem;
        padding:1rem;
        border-radius:18px;
    }

    .title{
        color:var(--page-header);
        font-family: var(--heading-font-bold);
        font-size: 1.6rem;
    }

    

     .breadcrumb-link{
            color:var(--navlink);
            text-decoration: none;
    }

    .job-details{
        display:grid;
        grid-template-rows: auto auto;
        row-gap: 0.1rem;
    }

    .sub-details{
        display: flex;
        column-gap: 1rem;
        color:var(--sidenav-link);
        font-size:0.9rem;
        font-family: var(--heading-font-regular);
    }

    

   

    nav a.router-link-exact-active {
            color: var(--navlink-active);
    }

/** Navbar */


/** Table */

/* Datatable base */
.table-content {
    overflow-x: auto;
}

#myTable {
    width: 100%;
    border-collapse: collapse;
    font-family: var(--font-family, Arial, Helvetica, sans-serif);
    font-size: 14px;
    color: var(--text-color, #222);
}

#myTable thead th {
    text-align: left;
    padding: 10px 12px;
    background: var(--table-header-bg, #f7f8fa);
    color: var(--table-header-color, #111);
    border-bottom: 1px solid rgba(0,0,0,0.08);
    position: sticky;
    top: 0;
    z-index: 2;
}



#myTable tbody td {
    padding: 10px 12px;
    border-bottom: 1px solid rgba(0,0,0,0.04);
    vertical-align: middle;
}

/* Row hover and stripe */
#myTable tbody tr:nth-child(odd) {
    background: var(--table-row-odd, #fff);
}
#myTable tbody tr:nth-child(even) {
    background: var(--table-row-even, #fbfbfb);
}
#myTable tbody tr:hover {
    background: rgba(0,0,0,0.03);
}

/** Table */
</style>